import { CardTransaction } from '@thera-hr/api-sdk/api/resources/api/resources/thera/resources/bridge/resources/bridgeApi/types';
import { convertDateToFormat } from 'utils/dateTime';

interface TransactionItemProps {
  transaction: CardTransaction;
}

// Categories that add funds to the card (deposits / credits); everything else is card usage (withdrawals / debits).
const CREDIT_CATEGORIES = new Set<CardTransaction['category']>(['crypto_funding', 'refund', 'crypto_return']);

const formatTxnAmount = (amount: string, currency: string) => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return '';
  return `${Math.abs(value).toFixed(2)} ${currency.toUpperCase()}`;
};

/**
 * Individual transaction item display
 */
export const TransactionItem = ({ transaction }: TransactionItemProps) => {
  const isCredit = CREDIT_CATEGORIES.has(transaction.category);
  const formattedAmount = formatTxnAmount(transaction.amount, transaction.currency);

  return (
    <div className="flex items-center justify-between gap-3 py-3">
      <div className="flex min-w-0 flex-col items-start gap-1">
        <p className="truncate text-sm font-medium text-neutral-200">
          {transaction?.merchantName || transaction?.description || 'N/A'}
        </p>
        <p className="text-xs font-normal text-neutral-400">
          {transaction.localTransactionDetails?.postedAt &&
            convertDateToFormat(transaction.localTransactionDetails.postedAt.getTime() / 1000, 'dd MMM, yyyy')}
        </p>
      </div>
      {formattedAmount && (
        <p className={`text-md font-medium ${isCredit ? 'text-emerald-400' : 'text-white'}`}>
          {isCredit ? '+' : '-'}
          {formattedAmount}
        </p>
      )}
    </div>
  );
};
